import { useEffect, useState } from "react";
import { getReportStrategyPineRequirements } from "../services/reportsApi";
import type { ReportStrategyPineRequirementsResponse } from "../types/reportStrategyPine";

export function useReportStrategyPineRequirements(): {
  data: ReportStrategyPineRequirementsResponse | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
} {
  const [data, setData] = useState<ReportStrategyPineRequirementsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const resp = await getReportStrategyPineRequirements();
        if (!cancelled) setData(resp);
      } catch (e) {
        if (!cancelled) {
          setData(null);
          setError(e instanceof Error ? e.message : "Failed to load requirements.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return {
    data,
    loading,
    error,
    reload: () => setTick((t) => t + 1),
  };
}
